<template>
    <a ref="dropdown" :class="'dropdown-toggle ' + themeClass" data-bs-toggle="dropdown" role="button" aria-expanded="false"><i class="me-1 fa fa-circle-user fa-lg"></i> My Profile</a>
    <ul class="dropdown-menu dropdown-menu-end">
        <li><a class="dropdown-item disabled text-dark" aria-disabled="true"><i class="me-2 fa fa-circle-user fa-lg"></i> {{ newusername || username }}</a></li>
        <li><hr class="dropdown-divider"></li>
        <li><a class="dropdown-item" href="" @click.prevent="editProfile"><i class="fa fa-user-edit"></i> Update Profile</a></li>
        <li><a class="dropdown-item" href="" @click.prevent="changeTheme"><i :class="'me-2 fa ' + themeIcon"></i> Change Theme</a></li>
        <li><a class="dropdown-item" href="" @click.prevent="changePassword"><i class="me-2 fa fa-key"></i> Change Password</a></li>
        <li><a class="dropdown-item" href="" @click.prevent="signout"><i class="me-2 fa fa-right-from-bracket"></i> Sign Out</a></li>
    </ul>

    <common-dialog ref="changePassword" title="Change Password" @hidden="reset" :disabled="loading">
        <template #body>
            <div v-if="success">
                <div class="success-checkmark">
                    <div class="check-icon">
                        <span class="icon-line line-tip"></span>
                        <span class="icon-line line-long"></span>
                        <div class="icon-circle"></div>
                        <div class="icon-fix"></div>
                    </div>
                </div>
                <h4 class="my-2 text-center">Success!</h4>
            </div>
            <form v-if="!success" @submit.prevent="submitPassword">
                <div class="row my-2 text-center">
                    <h6>Enter your current password and the new password.</h6>
                    <p>Passwords must be at least 10 characters long.</p>
                </div>
                <div class="row my-2">
                    <div class="col-md-6 m-auto">
                        <div class="form-floating">
                            <input type="password" v-model="password" name="password" :class="'form-control' + passwordErrorClass" @keyup.enter="submitPassword" placeholder="Current Password"
                                   autocomplete="current-password">
                            <label for="password" class="text-start">Current Password</label>
                        </div>
                    </div>
                    <div v-if="passwordError" class="col-md-12 m-auto">
                        <div class="small text-center text-danger">{{ passwordError }}</div>
                    </div>
                </div>
                <div class="row my-2">
                    <div class="col-md-6 m-auto">
                        <div class="form-floating">
                            <input type="password" v-model="newPassword" name="newPassword" :class="'form-control' + newPasswordErrorClass" @keyup.enter="submitPassword" placeholder="New Password"
                                   autocomplete="new-password">
                            <label for="newPassword" class="text-start">New Password</label>
                        </div>
                    </div>
                    <div v-if="newPasswordError" class="col-md-12 m-auto">
                        <div class="small text-center text-danger">{{ newPasswordError }}</div>
                    </div>
                </div>
                <div class="row my-2">
                    <div class="col-md-6 m-auto">
                        <div class="form-floating">
                            <input type="password" v-model="confirmPassword" name="confirmPassword" :class="'form-control' + confirmPasswordErrorClass" @keyup.enter="submitPassword" placeholder="Confirm Password"
                                   autocomplete="new-password">
                            <label for="confirmPassword" class="text-start">Confirm Password</label>
                        </div>
                    </div>
                    <div v-if="confirmPasswordError" class="col-md-12 m-auto">
                        <div class="small text-center text-danger">{{ confirmPasswordError }}</div>
                    </div>
                </div>
                <div v-if="error" class="row my-2">
                    <div class="col-md-12 m-auto">
                        <p class="alert alert-danger">{{ error }}</p>
                    </div>
                </div>
            </form>
        </template>
    </common-dialog>

    <common-dialog ref="profileDialog" title="Update Profile" :disabled="loading">
        <template #body>
            <div v-if="success">
                <div class="success-checkmark">
                    <div class="check-icon">
                        <span class="icon-line line-tip"></span>
                        <span class="icon-line line-long"></span>
                        <div class="icon-circle"></div>
                        <div class="icon-fix"></div>
                    </div>
                </div>
                <h4 class="my-2 text-center">Success!</h4>
            </div>
            <form v-if="!success" @submit.prevent="saveProfile">
                <div class="row my-2 text-center">
                    <h6>Click Save Changes to update your profile.</h6>
                    <p>First name, last name and either email or cell phone are required.</p>
                </div>
                <div class="row my-2">
                    <div class="col-md-8 m-auto">
                        <div class="form-floating">
                            <input type="text" v-model="user.firstName" name="firstname" :class="'form-control' + firstNameErrorClass" @keyup.enter="saveProfile" placeholder="First Name">
                            <label for="firstname" class="text-start">First Name</label>
                        </div>
                    </div>
                    <div v-if="firstNameError" class="col-md-12 m-auto">
                        <div class="small text-center text-danger">{{ firstNameError }}</div>
                    </div>
                </div>
                <div class="row my-2">
                    <div class="col-md-8 m-auto">
                        <div class="form-floating">
                            <input type="text" v-model="user.lastName" name="lastname" :class="'form-control' + lastNameErrorClass" @keyup.enter="saveProfile" placeholder="Last Name">
                            <label for="lastname" class="text-start">Last Name</label>
                        </div>
                    </div>
                    <div v-if="lastNameError" class="col-md-12 m-auto">
                        <div class="small text-center text-danger">{{ lastNameError }}</div>
                    </div>
                </div>
                <div class="row my-2">
                    <div class="col-md-8 m-auto">
                        <div class="form-floating">
                            <input type="email" v-model="user.primaryEmail" name="email" :class="'form-control' + emailErrorClass" @keyup.enter="saveProfile" placeholder="Email">
                            <label for="email" class="text-start">Email</label>
                        </div>
                    </div>
                    <div v-if="emailError" class="col-md-12 m-auto">
                        <div class="small text-center text-danger">{{ emailError }}</div>
                    </div>
                </div>
                <div class="row my-2">
                    <div class="col-md-8 m-auto">
                        <div class="form-floating">
                            <input type="tel" inputmode="tel" v-model="user.cellPhone" name="phone" :class="'form-control' + phoneErrorClass" @keyup.enter="saveProfile" placeholder="Cell Phone">
                            <label for="phone" class="text-start">Cell Phone</label>
                        </div>
                    </div>
                    <div v-if="phoneError" class="col-md-12 m-auto">
                        <div class="small text-center text-danger">{{ phoneError }}</div>
                    </div>
                </div>
                <div v-if="error" class="row my-2">
                    <div class="col-md-12 m-auto">
                        <p class="alert alert-danger">{{ error }}</p>
                    </div>
                </div>
            </form>
        </template>
    </common-dialog>
</template>
<script>
    import axios from 'axios';
    import CommonDialog from '../components/Dialog/CommonDialog';
    import Prefs from '../common/preferences';

    export default {
        props: ['username'],
        components: {
            CommonDialog
        },
        data: function () {
            return {
                password: '',
                newPassword: '',
                confirmPassword: '',
                error: '',
                passwordError: '',
                newPasswordError: '',
                confirmPasswordError: '',
                firstNameError: '',
                lastNameError: '',
                emailError: '',
                phoneError: '',
                loading: false,
                success: false,
                user: {
                    id: null,
                    firstName: '',
                    lastName: '',
                    primaryEmail: '',
                    cellPhone: '',
                },
                newusername: null
            }
        },
        methods: {
            changeTheme() {
                this.$refs.dropdown.click();
                Prefs.theme.value = Prefs.theme.value ? 0 : 1;
            },
            changePassword() {
                const vm = this;
                this.$refs.dropdown.click();
                this.reset();
                this.$refs.changePassword.show({
                    buttons: [{
                        id: 'cancel',
                        html: 'Cancel',
                        classes: 'btn-outline-dark',
                        dismiss: true
                    }, {
                        id: 'ok',
                        html: 'Change Password',
                        classes: 'btn-primary',
                        click() { vm.submitPassword() }
                    }]
                });
            },
            editProfile() {
                const vm = this;
                this.reset();
                this.$refs.dropdown.click();
                vm.loading = true;
                axios.get('/users/me').then(r => {
                    vm.user = r.data;
                    vm.$refs.profileDialog.show({
                        buttons: [{
                            id: 'cancel',
                            html: 'Cancel',
                            classes: 'btn-outline-dark',
                            dismiss: true
                        }, {
                            id: 'ok',
                            html: 'Save Changes',
                            classes: 'btn-primary',
                            click() { vm.saveProfile() }
                        }]
                    });
                    vm.loading = false;
                }).catch(e => {
                    window.location.reload();
                });
            },
            errorClassFor(condition) {
                return condition ? ' border-danger' : ''
            },
            reset() {
                this.password = '';
                this.newPassword = '';
                this.confirmPassword = '';
                this.error = '';
                this.passwordError = '';
                this.newPasswordError = '';
                this.confirmPasswordError = '';
                this.firstNameError = '';
                this.lastNameError = '';
                this.emailError = '';
                this.phoneError = '';
                this.loading = false;
                this.success = false;
            },
            saveProfile() {
                const vm = this;
                this.loading = true;
                axios.post('/users/me', this.user)
                    .then(r => {
                        vm.error = r.data.error;
                        vm.firstNameError = r.data.firstNameError;
                        vm.lastNameError = r.data.lastNameError;
                        vm.emailError = r.data.emailError;
                        vm.phoneError = r.data.phoneError;
                        vm.success = r.data.success;
                        vm.loading = r.data.success;
                        if (r.data.success) {
                            vm.newusername = vm.user.firstName + ' ' + vm.user.lastName;
                        }
                    })
                    .catch(e => {
                        vm.error = e.message || 'An error occurred saving the changes.  Please try again later.';
                        vm.loading = false;
                    });
            },
            submitPassword() {
                const vm = this;
                vm.loading = true;
                let data = {
                    password: vm.password,
                    newPassword: vm.newPassword,
                    confirmPassword: vm.confirmPassword,
                };
                axios.post('/users/changepassword', data)
                    .then(r => {
                        vm.error = r.data.error;
                        vm.passwordError = r.data.passwordError;
                        vm.newPasswordError = r.data.newPasswordError;
                        vm.confirmPasswordError = r.data.confirmPasswordError;
                        vm.success = r.data.success;
                        vm.loading = r.data.success;
                    }).catch(e => {
                        vm.error = e.message || 'An error occurred saving the new password.  Please try again later.';
                        vm.loading = false;
                    });
            },
            signout() {
                axios.post('/signout')
                    .then(r => {
                        Prefs.clear();
                        window.location.replace('/');
                    })
            }
        },
        computed: {
            passwordErrorClass() {
                return this.errorClassFor(this.passwordError);
            },
            newPasswordErrorClass() {
                return this.errorClassFor(this.newPasswordError);
            },
            confirmPasswordErrorClass() {
                return this.errorClassFor(this.newPasswordError || this.confirmPasswordError);
            },
            firstNameErrorClass() {
                return this.errorClassFor(this.firstNameError);
            },
            lastNameErrorClass() {
                return this.errorClassFor(this.lastNameError);
            },
            emailErrorClass() {
                return this.errorClassFor(this.emailError);
            },
            phoneErrorClass() {
                return this.errorClassFor(this.phoneError);
            },
            themeClass() {
                return Prefs.theme.value ? 'text-light' : 'text-dark';
            },
            themeIcon() {
                return Prefs.theme.value ? 'fa-sun' : 'fa-moon';
            },
        },
        watch: {
            success(success) {
                if (success) {
                    const vm = this;
                    setTimeout(function () {
                        vm.$refs.changePassword.hide();
                        vm.$refs.profileDialog.hide();
                    }, 2000);
                }
            }
        }
    }
</script>